import firebase from 'firebase'
import React, { Component } from 'react'
import { Board as BoardComponent } from '../../components/Board'
import { Board as IBoard } from 'minimax_ttt'
import { IRoom } from '../../models'
import { firestore } from '../../firebase';

type Props = {
  room: IRoom
  boards: { board: IBoard }[],
}

export class GameWithOnlinePlayer extends Component<Props> {
  getHistory() {
    return this.props.boards.slice(0, this.stepNumber() + 1)
  }

  getLatestBoard(): IBoard {
    return this.getHistory()[this.stepNumber()].board.slice() as IBoard
  }

  stepNumber() {
    return this.props.boards.length - 1
  }

  canPutONow() {
    const board = this.getLatestBoard()
    let oNum = 0
    let xNum = 0
    board.forEach(cell => {
      if (cell === 1) {
        oNum++
      } else if (cell === 2) {
        xNum++
      }
    })
    if (oNum === xNum) {
      return true
    } else if (oNum > xNum) {
      return false
    } else {
      return true
    }
  }

  isMyTurn(): boolean {
    const board = this.getLatestBoard()
    if (getWinner(board) !== null) {
      return false
    }

    return this.isRoomOwner() ? this.canPutONow() : !this.canPutONow()
  }

  isRoomOwner() {
    const user = firebase.auth().currentUser
    if (!user) {
      throw Error('なぜかuserが取れませんでした')
    }
    return this.props.room.roomOwnerId === user.uid
  }

  canIPut(i: number): boolean {
    const board = this.getLatestBoard()
    return this.isMyTurn() && board[i] === 0
  }

  handleClick(i: number) {
    if (!this.canIPut(i)) {
      return
    }
    const board = this.getLatestBoard()
    board[i] = this.canPutONow() ? 1 : 2;
    this.postBoard(board)
  }

  componentDidMount() {
    const history = this.props.boards
    const current = history[this.stepNumber()]
    if (getWinner(current.board) !== null) {
      return
    }

    if (this.props.room.startByRoomOwner) {
      if (this.isRoomOwner()) {
        alert('you are first hand')
      } else {
        alert('you are second hand')
      }
    } else {
      if (this.isRoomOwner()) {
        alert('you are second hand')
      } else {
        alert('you are first hand')
      }
    }
  }

  async postBoard(board: IBoard) {
    firestore.collection('room').doc(this.props.room.id).collection('boards').add({
      board,
      createdAt: firebase.firestore.FieldValue.serverTimestamp()
    })
  }

  render() {
    const history = this.props.boards
    const current = history[this.stepNumber()]
    const winner = getWinner(current.board)

    let status
    if (winner) {
      status = 'Winner: ' + winner
    } else {
      status = 'Next player: ' + (this.canPutONow() ? 'O' : 'X')
    }

    const moves = history.map((_, move) => {
      const desc = move ? 'Move #' + move : 'Game start'
      return (
        <li key={move}>
          <a href="#">{desc}</a>
        </li>
      )
    })

    return (
      <div className="game">
        <div className="game-board">
          <BoardComponent
            board={current.board.map(cell => cell === 0 ? '' : cell === 1 ? 'O' : 'X')}
            onClick={(i) => this.handleClick(i)}
          />
        </div>
        <div className="game-info">
          <div>{status}</div>
          <ol>{moves}</ol>
        </div>
      </div>
    )
  }
}

function getWinner(board: IBoard) {
  const lines = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6],
  ]
  for (let i = 0; i < lines.length; i++) {
    const [a, b, c] = lines[i]
    if (board[a] && board[a] === board[b] && board[a] === board[c]) {
      return board[a] === 1 ? 'O' : 'X'
    }
  }
  if (board.find(cell => cell === 0) === undefined) {
    return 'Nothing'
  }
  return null
}
